import React from 'react';

export default function Pagination(props) {
  const {
    total, limit, page, navigateToPage, leading,
  } = props;

  const buttonClass = "relative inline-flex items-center justify-center w-24 px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500"
  return (
    <div className="bg-white px-4 py-3 flex flex-wrap items-center justify-between gap-y-3 border-t border-gray-200 sm:px-6">
      {/* Optional left-hand slot. The bar is mostly empty on the left, so a
          caller with a summary to show (counts, filters) can put it on this
          line instead of stacking another row above. Full width below `sm`
          so it wraps clear of the Previous/Next buttons rather than
          squeezing them. */}
      {leading && <div className="w-full sm:w-auto">{leading}</div>}
      <div className="flex-1 flex justify-between sm:hidden">
        <button type="button" href="#" onClick={() => navigateToPage(page - 1)} className={buttonClass}>
          Previous
        </button>
        <button type="button" href="#" onClick={() => navigateToPage(Number(page) + 1)} className={buttonClass}>
          Next
        </button>
      </div>
      <div className="hidden sm:flex-1 sm:flex sm:items-end flex-col">
        <div>
          <p className="text-sm text-gray-700">
            Showing
            <span className="font-medium">
              {' '}
              {page * limit + 1}
              {' '}
            </span>
            to
            <span className="font-medium">
              {' '}
              {(((Number(page) + 1) * limit) > total) ? total : limit * (Number(page) + 1)}
              {' '}
            </span>
            of
            <span className="font-medium">
              {' '}
              {total}
              {' '}
              results
            </span>
          </p>
        </div>
        <div>
          <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
            <a href="#" onClick={() => navigateToPage(page - 1)} className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span className="sr-only">Previous</span>
              {/* <!-- Heroicon name: solid/chevron-left --> */}
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </a>
            
            <select value={page} onChange={(e) => navigateToPage(e.target.value)} className="cursor-pointer border-gray-300 focus:ring-0 focus:outline-none">
              {[...Array(Math.ceil(total / limit))].map((v, i) => (
                <option value={i} key={'page='+i}>
                  {i + 1}
                </option>
              ))}
            </select>
            <a href="#" onClick={() => navigateToPage(Number(page) + 1)} className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span className="sr-only">Next</span>
              {/* <!-- Heroicon name: solid/chevron-right --> */}
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </a>
          </nav>
        </div>
      </div>
    </div>
  );
}
